import LongList from './long-list'

export default LongList
